import { useEffect, useMemo, useState } from "react";
import GeneralTable from "../Tabellen/GeneralTable";
import DatenLaden from "../Tabellen/DatenLaden";
import { kreisHeader } from "../Tabellen/ConstTabKopf/KreisKopf";
import StammdatenExport from "../Stammdaten/StammdatenExport";


export default function KreisLaden({ instance, landInstance, setTable, goBack }) {
    const [data, setData] = useState();
    const [columns, setColumns] = useState();

    useEffect(() => {
        console.log("lade kreise")
        instance.getKreisKreisGet((error, data) => {
            if (error) {
                console.log(error);
            } else {
                setData(data);
                setColumns(kreisHeader);
            }
        });
    }, [instance]);

    const prepData = useMemo(() => data, [data]);

    const csvIt = loadedData => {
        return loadedData.map(it =>
        ({
            ...it,
            Kreis: it.kreis,
            Kreisnummer: it.nummer,
            'zugehörig zu': it.land
        }))
    }

    return (
        <div>
            {/* <KreisCreate kreisInstance={instance} landInstance={landInstance} reloadData={reloadData} /> */}
            {data && columns
                ? <div>
                    <GeneralTable data={prepData} columns={columns} hiddenColumns={['id', 'id_land']} additionalColumns={[]} />
                    <StammdatenExport csvedData={csvIt(prepData)} csvHeader={['Kreis', 'Kreisnummer', 'zugehörig zu']} csvFilename={"sd_kreis"} />
                </div>
                : <DatenLaden />}
        </div>
    );

}